import { InputText } from "primereact/inputtext";
import localeText from "../../../locale";

const PasswordFields = ({ password, setPassword, loading }) => {
  return (
    <div className="w-full">
      <label className="font-semibold text-sm" htmlFor="password" style={{ color: "#0D0D0E" }}>
        {localeText("password")}
      </label>
      <div className="mt-2">
        <InputText
          name="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-3"
          placeholder={localeText("enterPassword")}
          disabled={loading}
        />
      </div>
      <div className="text-xs mt-1" style={{ color: "#7A869A" }}>
        {localeText("passwordMin8")}
      </div>
    </div>
  );
};

export default PasswordFields;

